import { Ability, AbilityClass, ExtractSubjectType } from '@casl/ability';

export type Actions = 'write' | 'read' | 'manage' | 'create' | 'delete' | 'update' | 'add' | 'copy';
export type Subjects = aor | typeof aor | woc | typeof woc | vendorDoc | typeof vendorDoc | deadline | typeof deadline 
| basicInfo | typeof basicInfo | tagging | typeof tagging | sow | typeof sow | dotp | typeof dotp | tenderValidity | typeof tenderValidity | report | typeof report
|'document' | 'all';
class Entity {
    constructor(attrs: any) {
        // attrs = data to check rule condition with, if condition matches, then apply rule
        // Store attrs in this subject instance
        Object.assign(this, attrs);
    }
}
export const extractMySubjectType: any = (subject: any) => {
    return subject.constructor
}
export class basicInfo extends Entity{}
export class aor extends Entity {}
export class woc extends Entity{}
export class vendorDoc extends Entity{}
export class deadline extends Entity{}
export class tagging extends Entity{}

export class sow extends Entity{}
export class dotp extends Entity{}
export class tenderValidity extends Entity{}

export class report extends Entity{}

export type AppAbility = Ability<[Actions, Subjects]>;
export const AppAbility = Ability as AbilityClass<AppAbility>;

export enum AbilityField {
    Purchase_Executives_Report = 'purchase-executives-report',
    Type_Of_Requisition = 'type-of-requisition',
    AOR_Detail = 'detail',
    AOR_Price = 'price',
    WOC_Vendor_Selection = 'vendor-selection',
    WOC_DOTP = 'woc-dotp',
}